import styles from "../tos/tos.module.css";

function PrivacyPolicy() {
  return (
    <div className={styles.tos}>
      <div className={styles.card}>
        <h1>Privacy Policy</h1>
        <p>Last Updated: 3rd June 2025</p>
        <p>
          This Privacy Policy describes how Steedie collects, uses, and
          discloses information about users when using the services. By using
          these services, users agree to the collection and use of their
          information in accordance with this Privacy Policy.
        </p>
        <h2>Information Collection</h2>
        <p>Steedie collects the following types of information:</p>
        <ul>
          <li>
            <strong>Steam ID:</strong> Used for login and user identification.
          </li>
          <li>
            <strong>Uploaded Ads:</strong> Used to display on the ad network
            based on the user's subscription.
          </li>
        </ul>
        <p>Steam ID and uploaded ads are stored securely in AWS DynamoDB.</p>
        <h2>Third-Party Services</h2>
        <p>
          The following third-party services are used to support operations:
        </p>
        <ul>
          <li>
            <strong>AWS (Amazon Web Services):</strong> For APIs, data storage,
            and hosting.
          </li>
          <li>
            <strong>Stripe:</strong> For payment processing.
          </li>
        </ul>
        <p>
          For more information on how AWS and Stripe handle data, please refer
          to their respective privacy policies.
        </p>
        <h2>Data Security</h2>
        <p>
          Steedie takes reasonable measures to secure information, but no method
          of electronic transmission or storage is 100% secure.
        </p>
        <h2>Changes to This Policy</h2>
        <p>
          Steedie may update this Privacy Policy from time to time. Changes will
          take effect upon posting, as indicated by the "Last Updated" date at
          the top of this Privacy Policy.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
